<script>
import {
  CdrLink,
} from '@rei/cedar';

import EaPicture from '../../../components/eaPicture.vue';

export default {
  name: 'EditorsChoiceAwardResultTile',
  components: {
    CdrLink,
    EaPicture,
  },
  props: {
    award: {
      type: Object,
      default: null,
    },
  },
  methods: {
    getAltText(award) {
      const alt = award.heroImageInfos.find((x) => x.key === 'all-awards-mobile' || x.key === 'all-awards-desktop').heroImageInfo.altText;
      return alt || '';
    },
  },
};
</script>

<template>
  <div class="ea-editors-choice-award-result-tile">
    <ea-picture
      class="ea-editors-choice-award-result-tile__product_image"
      :alt-text="getAltText(award)"
      :lg-src="award.heroImageInfos[0].heroImageInfo.url"
    />
    <div class="ea-editors-choice-award-result-tile__award_year">
      {{ award.metadata.year }}
    </div>
    <div class="ea-editors-choice-award-result-tile__details">
      <h3 class="ea-editors-choice-award-result-tile__product_name">
        {{ award.productName || '' }}
      </h3>
      <div class="ea-editors-choice-award-result-tile__product_description">
        <p>
          {{ award.shortDescription }}
        </p>
        <div class="ea-editors-choice-award-result-tile__links">
          <cdr-link
            v-if="award.reviewLink"
            class="ea-editors-choice-award-result-tile__link"
            :href="award.reviewLink"
            :data-analytics-id="`all winners_read full review_${award.productName}`"
          >
            Read Full Review
          </cdr-link>
          <cdr-link
            v-if="award.productLink"
            class="ea-editors-choice-award-result-tile__link"
            :href="award.productLink"
            :data-analytics-id="`all winners_shop now_${award.productName}`"
          >
            Shop Now
          </cdr-link>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens';

.ea-editors-choice-award-result-tile {
  color: $cdr-color-text-inverse;
  position: relative;
  overflow: hidden;
  width: 330px;

  @include cdr-xs-mq-only {
    width: 100%;
  }

  .ea-editors-choice-award-result-tile__product_image {
    height: 460px;

    @include cdr-xs-mq-only {
      height: 150vw;
    }
  }

  .ea-editors-choice-award-result-tile__award_year {
    position: absolute;
    top: 0;
    right: $cdr-space-one-and-a-half-x;
    padding: $cdr-space-half-x $cdr-space-three-quarter-x;
    border-radius: 0 0 10px 10px;
    background-color: $cdr-color-background-button-primary-rest;

    @include cdr-text-heading-serif-800;
  }

  .ea-editors-choice-award-result-tile__details {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: $cdr-space-inset-three-x-stretch-top-bottom $cdr-space-one-x $cdr-space-one-x $cdr-space-one-x;
    flex-direction: column;
    display: flex;
    background: linear-gradient(1turn,rgb(0 0 0 / 80%),rgb(0 0 0 / 50%) 65%, transparent);
  }

  .ea-editors-choice-award-result-tile__product_name {
    @include cdr-text-heading-serif-600;
  }

  .ea-editors-choice-award-result-tile__product_description {
    flex: 1 1 45%;
    display: flex;
    flex-direction: column;
    justify-content:space-between;
    gap: $cdr-space-one-x;

    @include cdr-text-utility-sans-300;
  }

  .ea-editors-choice-award-result-tile__links {
    display: flex;
    justify-content:space-around;
    gap: $cdr-space-one-x;
  }

  .ea-editors-choice-award-result-tile__link {
    @include cdr-text-utility-sans-300;

    color: $cdr-color-text-inverse;
    border: solid 1px transparent;
    padding: $cdr-space-half-x $cdr-space-one-x;

    &:hover,&:focus {
      text-decoration: none;
      color: $cdr-color-text-inverse;
      border-radius: $cdr-radius-softer;
      border: solid 1px $cdr-color-border-primary;
    }
  }
}

</style>
